<template>
    <div class="text-end">
        <div>
            Masz pytania? Napisz do nas:<br/>
            <a href="mailto:pomoc@klubpirelli.pl">pomoc@klubpirelli.pl</a>
        </div>
    </div>
</template>

<script>
export default {
    name: "FooterInfoComponent"
}
</script>
